export default __webpack_public_path__ + "static/media/central_andes_1_17.3ccaca29.JPG";